export const DEBUG = false
export const API_ENDPOINT = DEBUG? "http://localhost:8000": "https://meritresearchjournals.org"